import React from 'react'

const ResolvedTicket = () => {
  return (
    <div>ResolvedTicket</div>
  )
}

export default ResolvedTicket